<mat-form-field>
  <mat-label>{{ label() }}</mat-label>
  <textarea
    matInput
    [placeholder]="placeholder()"
    disabled
  ></textarea>
</mat-form-field>
